import { CreatorIntegrationsV2ApiClient } from '@fourthwall/services/dist/CreatorIntegrationsV2ApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useCreatorIntegrationsV2Query = createQueryHook(
  CreatorIntegrationsV2ApiClient.getCreatorIntegrationsV2,
  {
    queryKey: ['creatorIntegrationsV2'],
  },
)
